import router from '@/modules/accessibilityFeedback/router'

export default {
  router,
}
